import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=9fd91366&scoped=true&lang=html&"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=9fd91366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd91366",
  null
  
)

export default component.exports